import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiaryEntry } from './components/DiaryEntry';
import { PullQuote } from './components/PullQuote';
import { ProductReveal } from './components/ProductReveal';
import { InlineCTA } from './components/InlineCTA';
import { ProductExplanation } from './components/ProductExplanation';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { BeforeAfter } from './components/BeforeAfter';
import { TrustBar } from './components/TrustBar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Initialize dataLayer before GTM script
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-forest selection:text-cream overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />

        <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-4">
          <DiaryEntry title="Das Problem" date="12. Dezember 2025" text={<>
                <strong data-id="element-6">Balu hat wieder Durchfall.</strong> Zum dritten Mal
                diese Woche. Ich putze den Garten, wasche seine Decke, mache mir
                Sorgen. Der Tierarzt verschreibt Schonkost. Es hilft – aber nur
                kurz. Kaum wechsle ich das Futter, geht es von vorne los. Ich
                wusste nicht mehr weiter.
              </>} delay={0.1} data-id="element-5" />

          <DiaryEntry title="Der Wendepunkt" date="22. Januar 2026" text={<>
                Eine Kollegin erzählt mir von einem Futtertopping, das sie ihrem
                Labrador gibt.{' '}
                <strong data-id="element-8">
                  Pflanzlich, keine Zusätze, mit Präbiotika und Ballaststoffen.
                </strong>{' '}
                Ich googele stundenlang. Lese Erfahrungsberichte. Ich hatte
                schon so viele Sachen ausprobiert — aber dann sah ich, dass fast
                900 andere Hundehalter das Topping bewertet hatten, viele mit
                genau denselben Problemen wie Balu. Bestelle es schließlich –
                mit wenig Hoffnung aber großer Verzweiflung.
              </>} delay={0.2} data-id="element-7" />

          <PullQuote data-id="element-9" />

          <DiaryEntry title="Die Veränderung" date="29. Januar 2026" text={<>
                Ich schleiche das Topping langsam ein wie empfohlen. Erstmal ein
                kleiner Löffel. Balu frisst es problemlos. Nach 5 Tagen: der
                Stuhl wird fester. Ich traue meinen Augen kaum.{' '}
                <strong data-id="element-11">
                  Nach 10 Tagen hatte Balu zum ersten Mal wieder normalen Stuhl.
                </strong>{' '}
                Ich weine vor Erleichterung.
              </>} delay={0.3} data-id="element-10" />

          <InlineCTA label="Das Topping das Balu geholfen hat → hier testen" position="story_cta" data-id="element-12" />

          <ProductReveal data-id="element-13" />

          <DiaryEntry title="Heute" date="13. März 2026" text={<>
                Balu bekommt das Topping jeden Morgen ins Futter. Es ist Teil
                unserer Routine geworden. Er liebt es, ich liebe die Ruhe. Keine
                Angst mehr vor dem Morgen.{' '}
                <strong data-id="element-15">Sein Bauch hat sich komplett beruhigt.</strong> Endlich
                können wir wieder entspannt spazieren gehen.
              </>} image="https://images.unsplash.com/photo-1612774412771-005ed8e861d2?w=800&q=80" delay={0.4} data-id="element-14" />
        </section>

        <ProductExplanation data-id="element-16" />

        <InlineCTA label="Jetzt für meinen Hund bestellen" position="ingredients_cta" data-id="element-17" />

        <ExpertQuote data-id="element-18" />
        <Testimonials data-id="element-19" />
        <FAQ data-id="element-20" />
        <BeforeAfter data-id="element-21" />
        <TrustBar data-id="element-22" />
        <CTASection data-id="element-23" />
      </main>

      <Footer data-id="element-24" />
    </div>;
}